import { ref, reactive } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-655b261f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送状态", -1));
const _hoisted_3 = {
  class: "status-content"
};
const _hoisted_4 = {
  class: "status-title"
};
const _hoisted_5 = {
  class: "flex-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prompt-title"
}, "只支持复送一个月以内的订单", -1));
const _hoisted_7 = {
  class: "button-content"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, null, -1));
const _hoisted_9 = {
  class: "right"
};
import { resendOrder } from '@/api/orderApi';
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderModal',
  emits: ['updateList'],
  setup(__props, {
    expose,
    emit
  }) {
    const dataSource = ref({});
    // const countryList = [
    //   { label: '国内', value: 'foreign' },
    //   { label: '国外', value: 'homeland' },
    // ]
    const visible = ref(false);
    const orderForm = reactive({
      orderNo: '',
      prodId: '',
      location: 'foreign'
    });
    const orderRef = ref(null);
    //根据 prodResend 字段判断, 如果为 0 - 不复送  1 - 复送中 2 复送完成
    const resendTip = {
      0: '未复送',
      1: '复送中',
      2: '复送完成'
    };
    const prodResendType = ref('');
    const handleOk = () => {
      if (orderForm.prodId === '') {
        message.error('内购ID不能为空');
        return;
      }
      resendOrder(orderForm).then(res => {
        if (res.code === OK) {
          message.success('复送成功');
          // 延迟刷新订单查询列表
          setTimeout(() => {
            emit('updateList');
            visible.value = false;
          }, 1000);
          reportEvent({
            eventName: 'element_use',
            properties: {
              'ui_name': '订单查询',
              'element_name': '复送订单'
            }
          });
        }
      }).catch(err => {});
      // emit('update:modalVisible', false)
    };
    const closeModal = () => {
      orderRef.value.resetFields();
      visible.value = false;
    };
    const showModal = item => {
      visible.value = true;
      dataSource.value = item;
      orderForm.prodId = item.prodId;
      orderForm.orderNo = item.orderNo;
      prodResendType.value = item.prodResend || '';
    };
    // const handleResend = () => {
    //   queryResendOrder({orderNo:orderForm.orderNo,location:orderForm.location}).then((res: any) => {
    //     console.log('%c [ res ]-83', 'font-size:13px; background:pink; color:#bf2c9f;', res)
    //     // if (res.code === OK) {
    //     //   message.success('复送成功')
    //     //   emit('updateList')
    //     //   visible.value = false;
    //     // } else {
    //     //   message.error('复送失败')
    //     // }
    //   })
    // }
    expose({
      showModal
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        title: "复送订单",
        open: visible.value,
        "onUpdate:open": _cache[2] || (_cache[2] = $event => visible.value = $event),
        width: "578px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "order",
          model: orderForm,
          ref_key: "orderRef",
          ref: orderRef,
          layout: "vertical"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "订单编号：",
            name: "orderNo"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.orderNo,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => orderForm.orderNo = $event),
              placeholder: "请输入订单编号",
              disabled: ""
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "内购ID：",
            name: "prodId",
            rules: [{
              required: true,
              message: '请填写内购ID!'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.prodId,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => orderForm.prodId = $event),
              placeholder: "请输入内购ID",
              disabled: ""
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
          "icon-class": "no_send",
          "class-name": "status-icon"
        }), _createElementVNode("div", _hoisted_4, _toDisplayString(resendTip[prodResendType.value]), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_svg_icon, {
          "icon-class": "prompt",
          "class-name": "prompt-icon"
        }), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_button, {
          onClick: closeModal
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          class: "submit-btn",
          onClick: handleOk
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});